import { LESSON_STATUS } from '@yandex-int/k-common/typings';
import { createSelector } from 'reselect';

import * as lessonSelectors from 'common.components/lesson/selectors';
import { getIsLessonAvailableForChildren } from 'common.components/lesson/utils';
import { isMobileSelector } from 'utils/selectors/selectors';

import * as sidePanelSelectors from '../selectors';
import { SIDE_PANEL_MODE } from '../side-panel-mode';

export const getShouldShowCopyLessonLink = createSelector(
    [
        lessonSelectors.getLessonStatus,
        lessonSelectors.getIsLessonCourseClosed,
        sidePanelSelectors.getSidePanelMode,
        sidePanelSelectors.getShouldShowCopyLinkInput,
        isMobileSelector,
    ],
    (
        status: LESSON_STATUS | null,
        isLessonCourseClosed: boolean,
        sidePanelMode: SIDE_PANEL_MODE,
        shouldShowCopyLinkInput: boolean,
        isMobile
        // eslint-disable-next-line max-params
    ): boolean => {
        const shouldNotShowInput = isMobile || !shouldShowCopyLinkInput;
        const isLessonAvailableForChildren = getIsLessonAvailableForChildren(status);
        return (
            (isLessonAvailableForChildren && shouldNotShowInput && !isLessonCourseClosed) ||
            sidePanelMode === SIDE_PANEL_MODE.REASSIGNMENT
        );
    }
);
